import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var categorySchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    bg_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на български',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на английски',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден slug',
    }),
    parent_id: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'autocomplete',
        label: 'Бащина категория',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна бащина категория',
    }),
    home_visible: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Видима на началната страница',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    brand_hidden: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Скрита от бранд-менюто',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    header_hidden: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Скрита от навигацията',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    meta_title: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'input',
        label: 'Meta Заглавие',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно заглавие',
    }),
    meta_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Meta Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно описание',
    }),
    image: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'image',
        label: 'Картинка',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден адрес',
    }),
};
export default categorySchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/categorySchema.ts
// module id = 333
// module chunks = 0